import { RampConfig, RampShape } from './types';

export interface Platform {
  kind: 'head' | 'turn-landing' | 'rest-landing';
  minSizeIn: { w: number; d: number };
}

const MM_TO_IN = 25.4;
const CCQ_MAX_RUN_MM = 9000;
const CCQ_MAX_RUN_IN = CCQ_MAX_RUN_MM / MM_TO_IN;
const LANDING_MIN_IN = 1500 / MM_TO_IN;

function longestRun(shape: RampShape): number {
  switch (shape.kind) {
    case 'straight':
      return shape.totalRunIn;
    case 'L90':
      return Math.max(shape.arm1RunIn, shape.arm2RunIn);
    case 'U180':
      return Math.max(shape.arm1RunIn, shape.arm2RunIn);
    case 'switchback':
      return Math.max(...shape.segments.map((s) => s.runIn));
    case 'freeform':
      return 0;
  }
}

export function computePlatforms(config: RampConfig): Platform[] {
  const platforms: Platform[] = [{ kind: 'head', minSizeIn: { w: 48, d: 48 } }];

  if (config.shape.kind === 'L90' || config.shape.kind === 'U180') {
    platforms.push({ kind: 'turn-landing', minSizeIn: { w: LANDING_MIN_IN, d: LANDING_MIN_IN } });
  }

  const lr = longestRun(config.shape);
  if (lr > CCQ_MAX_RUN_IN) {
    const numRestLandings = Math.floor(lr / CCQ_MAX_RUN_IN);
    for (let i = 0; i < numRestLandings; i++) {
      platforms.push({
        kind: 'rest-landing',
        minSizeIn: { w: LANDING_MIN_IN, d: LANDING_MIN_IN },
      });
    }
  }
  return platforms;
}
